import type { Component } from 'vue'

import { IconAlert } from '@ds/icons/IconAlert'
import { IconInfo } from '@ds/icons/IconInfo'
import { IconThumbsUpOutlined } from '@ds/icons/IconThumbsUpOutlined'
import { IconWarning } from '@ds/icons/IconWarning'

import type { Banner } from '~/api/banners/types'

export const LINK_IDENTIFIER = '%%'

export const BANNER_TYPES: Record<
  Banner['type'],
  { backgroundClass: string; icon: Component }
> = {
  INFO: {
    backgroundClass: 'bg-static-info-mid',
    icon: IconInfo,
  },
  WARNING: {
    backgroundClass: 'bg-static-warning-mid',
    icon: IconAlert,
  },
  ERROR: {
    backgroundClass: 'bg-static-danger-mid',
    icon: IconWarning,
  },
  SUCCESS: {
    backgroundClass: 'bg-static-success-mid',
    icon: IconThumbsUpOutlined,
  },
  NEUTRAL: {
    backgroundClass: 'bg-static-default-mid',
    icon: IconInfo,
  },
}
